enum UserStatusEnum {
  all = 'all',
  active = 'active',
  inactive = 'inactive',
  retired = 'retired',
  unknow = 'unknow'
}
export { UserStatusEnum };
